import { render, staticRenderFns } from "./news_list.vue?vue&type=template&id=b00b4e42&scoped=true&"
import script from "./news_list.vue?vue&type=script&lang=js&"
export * from "./news_list.vue?vue&type=script&lang=js&"
import style0 from "./news_list.vue?vue&type=style&index=0&lang=css&"
import style1 from "./news_list.vue?vue&type=style&index=1&id=b00b4e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00b4e42",
  null
  
)

export default component.exports